export default __webpack_public_path__ + "static/kyc-6d7582b82fee0b1012a67de0f04c313c.png";